import React from 'react';
import Station from "../../components/Station/Station";
import "./StationList.css";
import {SearchBar} from "../../components";

function StationList({search, setSearch, currentStation, filteredStations, setCurrentStation, isPlaying, STATIONS}) {
	return (
		<section className="stations-panel">
			<div className="panel-header">
				<h2 className="panel-title">Stations</h2>
				<span className="panel-count">
                {filteredStations.length} of {STATIONS.length}
              </span>
			</div>

			<SearchBar search={search} setSearch={setSearch}/>
			<List currentStation={currentStation} filteredStations={filteredStations} isPlaying={isPlaying}
			      setCurrentStation={setCurrentStation}/>
		</section>
	)
}

function List({currentStation, filteredStations, setCurrentStation, isPlaying}) {
	return (
		<div className="stations-list">
			{filteredStations.map((station) => {
				const isActive =
					currentStation && currentStation.id === station.id;
				return (
					<button
						key={station.id}
						type="button"
						className={"station-card" + (isActive ? " station-card--active" : "")}
						onClick={() => setCurrentStation(station)}
					>
						<Station
							station={station}
							isActive={isActive}
							isPlaying={isPlaying}
						/>
					</button>
				);
			})}
			{filteredStations.length === 0 && (
				<p className="empty-message">
					Nothing here yet. Try another word?
				</p>
			)}
		</div>
	)
}

export default StationList;